import React, { useEffect, useState, Fragment, useContext } from 'react';
import CartDetail from './CartDetail';
import PlaceOrder from './PlaceOrder';
import PlaceOrderResponse from './PlaceOrderResponse';
import CartRepository from './CartRepository';
import { PostData } from './Fetch';
import { TranslationContext, SettingsContext } from "./Context";
import GrayInfoBox from './GrayInfoBox';

function Cart(props) {

    const translation = useContext(TranslationContext);
    const settings = useContext(SettingsContext);
    const [orderPlaced, setOrderPlaced] = useState(false);
    const [items, setItems] = useState(null);
    const [articles, setArticles] = useState([]);

    useEffect(() => {
        const repo = new CartRepository();
        const items = repo.cart.items;
        const legacyArticleIds = items.map(i => i.legacyArticleId);

        if (legacyArticleIds.length > 0 && articles.length === 0) {
            PostData(`/language/${settings.language}/country/${settings.market}/articles/searchbylegacyarticleid`, legacyArticleIds)
                .then(data => {
                    items.map(i => {
                        i.article = data.articles.find(a => a.articleNumber === i.articleNumber);
                    });

                    setArticles(data.articles);
                    setItems(items);
                });
        }
        else {
            setItems(items);
        }
    }, []);

    function handlePlaceOrder(e) {
        setOrderPlaced(true);
        let cartRepository = new CartRepository();
        cartRepository.newCart();
    }

    function handleItemChange(articleNumber, legacyArticleId, qty) {
        const repo = new CartRepository();
        repo.update(articleNumber, legacyArticleId, qty);
        setItems(repo.cart.items);
    }

    function handleItemRemove(articleNumber) {
        const repo = new CartRepository();
        repo.remove(articleNumber);
        setItems(repo.cart.items);
    }

    return (
        <Fragment>
            {!orderPlaced && items && items.length > 0 &&
                <Fragment>
                    <CartDetail onItemChange={handleItemChange} onItemRemove={handleItemRemove} articles={articles} items={items} />
                    <PlaceOrder onPlaceOrder={handlePlaceOrder} items={items} countries={props.countries} />
                </Fragment>}
            {!orderPlaced && (items !== null && items.length === 0) &&
                <Fragment>
                    <GrayInfoBox>
                        <h2 className="u-textBold28">{translation["TecAlliencePartSearch.CartSummary.NoItemsInCart"]}</h2>
                        <div className="u-mbottom20">{translation["TecAlliencePartSearch.CartSummary.NoItemsInCartExtraInformation"]}</div>
                        <p>
                            <a href={settings.continueShoppingUrl} className="btn btn-primary u-xsBlock">{translation["TecAlliencePartSearch.CartSummary.KeepShopping"]}</a>
                        </p>
                    </GrayInfoBox>

                </Fragment>
            }
            {orderPlaced && <PlaceOrderResponse />}
        </Fragment>
    );

}

export default Cart;